import WebConsoleLoggerHandler from "@vicman-wi/tools-js/esm/logger/WebConsoleLoggerHandler";
import {Logger} from "@vicman-wi/tools-js/esm/logger";

let loggerInstance = null;

/** @return {Logger} */
function logger() {
  if (loggerInstance) return loggerInstance;

  const logger = new Logger({
    levels:
      window.clientConfig.isTester || window.appConfig.isDebug ? undefined : [],
    tags:
      window.clientConfig.isTester || window.appConfig.isDebug ? undefined : [],
  });

  logger.addHandler(
    new WebConsoleLoggerHandler(
      window.clientConfig.isWebviewIos,
      window.clientConfig.isWebview
        ? (data) => JSON.stringify(data)
        : (data) => data
    )
  );

  loggerInstance = logger;
  return loggerInstance;
}

export default logger; 